const STORAGE_KEY = 'tkh-postal-code';
const HIDDEN_MODE = 'hidden';
const VISIBLE_MODE = 'visible';

const normalizePostalCode = (value = '') => value.trim().toUpperCase().replace(/[^A-Z0-9]/g, '');

class PostalCodeGate extends HTMLElement {
  /** @type {HTMLDialogElement | null} */
  dialog = null;

  /** @type {HTMLInputElement | null} */
  input = null;

  /** @type {HTMLElement | null} */
  error = null;

  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    this.input = this.querySelector('[data-postal-code-input]');
    this.error = this.querySelector('[data-postal-code-error]');

    this.querySelector('form')?.addEventListener('submit', this.handleSubmit);
    this.dialog?.addEventListener('cancel', this.preventDismiss);

    if (this.dataset.designMode !== 'true' && !this.getStoredPostalCode()) {
      requestAnimationFrame(() => this.open());
    }
  }

  disconnectedCallback() {
    this.querySelector('form')?.removeEventListener('submit', this.handleSubmit);
    this.dialog?.removeEventListener('cancel', this.preventDismiss);
  }

  preventDismiss = (event) => event.preventDefault();

  getStoredPostalCode() {
    try {
      return window.localStorage.getItem(STORAGE_KEY)?.trim() || '';
    } catch (_error) {
      return '';
    }
  }

  open() {
    if (!this.dialog?.open) this.dialog?.showModal();
    requestAnimationFrame(() => this.input?.focus());
  }

  /** @param {SubmitEvent} event */
  handleSubmit = (event) => {
    event.preventDefault();
    const postalCode = this.input?.value.trim() || '';
    const normalizedPostalCode = normalizePostalCode(postalCode);

    if (!normalizedPostalCode) {
      if (this.error) this.error.hidden = false;
      this.input?.setAttribute('aria-invalid', 'true');
      this.input?.focus();
      return;
    }

    try {
      window.localStorage.setItem(STORAGE_KEY, postalCode);
    } catch (_error) {
      // The gate still works for this page when storage is unavailable.
    }

    const excludedPostalCodes = (this.dataset.excludedPostalCodes || '')
      .split(/[\n,;]+/)
      .map(normalizePostalCode)
      .filter(Boolean);
    const mode = excludedPostalCodes.includes(normalizedPostalCode) ? HIDDEN_MODE : VISIBLE_MODE;

    document.documentElement.dataset.boxReviewPostalMode = mode;
    document.documentElement.dataset.customerPostalCode = normalizedPostalCode;
    document.dispatchEvent(
      new CustomEvent('postal-code:change', {
        detail: { postalCode, normalizedPostalCode, boxReviewMode: mode },
      })
    );

    if (this.error) this.error.hidden = true;
    this.input?.removeAttribute('aria-invalid');
    this.dialog?.close();
  };
}

if (!customElements.get('postal-code-gate')) {
  customElements.define('postal-code-gate', PostalCodeGate);
}
